<template>
  <div class="xcard">
    <v-btn small class="mx-0" @click="$router.back()" color="info" tile outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <h4 class="text-primary text-center">ENTREGA O REMISIÓN DE PROYECTOS</h4>
    <p class="ma-0">SEDE ESAM: TARIJA 1</p>
    <p class="ma-0">Responsable DNA - ESAM: EGBERTO BURGOS ERAZO</p>

    <v-row>
      <v-col sm="3">
        <label>AREA</label>
        <v-select dense outlined :items="areas" item-text="nombre" :loading="loading" return-object></v-select>
      </v-col>
      <v-col sm="3">
        <label>TIPO</label>
        <v-select dense outlined :items="tipos" item-text="nombre" :loading="loading" return-object></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="3">
        <label>VERSIÓN</label>
        <v-select dense outlined></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="6">
        <label>NOMBRE COMPLETO DEL PROYECTO</label>
        <v-text-field dense outlined></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="5">
        <label>ADJUNTAR EL PROYECTO (FORMATO WORD)</label>
        <v-file-input dense outlined></v-file-input>
      </v-col>
    </v-row>

    <v-btn class="green mr-4" dark>Habilitar</v-btn>
    <v-btn class="orange" dark>Cancelar</v-btn>
  </div>
</template>

<script>
  import gql from 'graphql-tag';
  export default {
    data() {
      return {
        loading: false,
        areas: [],
        tipos: [],
      };
    },
    methods: {
      getareasbyunidad() {
        this.loading = true;
        const sql = gql`query{
            areas: getAreas(unidad_negocio_id:${this.$store.state.UNIDAD_NEGOCIO_ID}){id,nombre,unidad_negocio_id}
            tipos: getCategorias(unidad_negocio_id:${this.$store.state.UNIDAD_NEGOCIO_ID}) {,id,nombre,descripcion,estado,unidad_negocio_id }}`;
        this.$apollo
          .query({ query: sql })
          .then(({ data }) => {
            window.console.log('--------------', data);
            this.areas = data.areas;
            this.tipos = data.tipos;
            this.loading = false;
          })
          .catch((error) => {
            window.console.error(error);
          });
      },
    },
    mounted() {
      this.getareasbyunidad();
    },
  };
</script>
